import {accessAdstellar} from '@/js/api/fetchData'
import apiRoutes from "@/js/api/api-routes";

export default {
  getMeta() {
    return accessAdstellar.get(apiRoutes.meta)
  },
}
